import { Element } from "@xmpp/xml"
import { jid } from "@xmpp/client"
import { Bookmark } from "../api/xeps/PepNativeBookmarks"

export type BookmarkEvent =
  | { from: string; type: "create"; bookmark: Bookmark }
  | { from: string; type: "retract"; jid: string }

class BookmarkEventParser {
  static parse(stanza: Element): BookmarkEvent | undefined {
    const node = stanza
      .getChild("event")
      ?.getChildByAttr("node", "urn:xmpp:bookmarks:1")

    if (!node) return

    const from = stanza.getAttr("from") as string

    if (node.getChild("item")) {
      const item = node.getChild("item")!
      const conference = item.getChild("conference")
      if (!conference) return

      return {
        from: from,
        type: "create",
        bookmark: {
          jid: jid.parse(item.getAttr("id")).bare().toString(),
          autojoin: conference.getAttr("autojoin") === "true",
          name: conference.getAttr("name"),
        },
      }
    } else if (node.getChild("retract")) {
      return {
        from: "from",
        type: "retract",
        jid: node.getChild("retract")?.getAttr("id"),
      }
    }
  }
}

export default BookmarkEventParser
